// 公共配置参数
let UMOOC_COOKIE_DOMAIN = '.tongshike.cn'
// courseapi
let COURSE_API_HOST = 'https://courseapi.tongshike.cn'
// let COURSE_API_HOST = 'http://192.168.8.36:1111'
let TEST_API_HOST = 'https://homeworkapi.tongshike.cn'
let KG_API_HOST = 'https://knowledgeapi.tongshike.cn'
let UTEST_API_HOST = 'https://utestapi.tongshike.cn'
let UMOOC_SERVER_HOST = 'https://www.tongshike.cn'
let UA_API_HOST = 'https://api.tongshike.cn'
let UTEST_WEB_HOST = 'https://utest.tongshike.cn'
 //let COURSE_API_HOST = '192.168.3.234'
 //let TEST_API_HOST = 'http://192.168.3.234:18282'
let UMOBILE_HOST = 'https://umobile.tongshike.cn'
// 上传base64编码图片接口
let QINIU_BASE64_URL = 'https://up.qbox.me/putb64/-1'
// 七牛访问地址
let RESOURCE_SERVER_HOST = 'https://leicloud.ulearning.cn'
// 七牛下载地址（针对水印合成图片）
const RESOURCE_DOWNLOAD_HOST = 'https://download.ulearning.cn'
// 文档预览地址
let DOCS_HOST = 'https://docs.ulearning.cn'

let WXPCLOGINAPPID = 'wx6bf391f8f1bc8776';  //pc微信扫码登录
let WXGZHAPPID = 'wxd8120ff1adc0eb60' //  //优学院公众号appid 微信浏览器唤起微信登录等使用

let ORG_SITE = location.host.substring(0, location.host.indexOf('.'))
if (location.host.includes('localhost') || location.host.includes('192.168')) {
  ORG_SITE = 'umooc'
}

let isI18n = false
if (location.hostname.indexOf('.tongshike.cn') !== -1) {
  UMOOC_COOKIE_DOMAIN = '.tongshike.cn'
} else if (location.hostname.indexOf('.ulearning.cn') !== -1) {
  UMOOC_COOKIE_DOMAIN = '.ulearning.cn'
  COURSE_API_HOST = 'https://courseapi.ulearning.cn'
  KG_API_HOST = 'https://knowledgeapi.ulearning.cn'
  TEST_API_HOST = 'https://homeworkapi.ulearning.cn'
  UMOBILE_HOST = 'https://umobile.ulearning.cn'
  UTEST_API_HOST = 'https://utestapi.ulearning.cn'
  UTEST_WEB_HOST = 'https://utest.ulearning.cn'
  UA_API_HOST = 'https://api.ulearning.cn'
  UMOOC_SERVER_HOST = 'https://www.ulearning.cn'
  WXPCLOGINAPPID = 'wx5d5eb33d5f4d5e9c'
} else if (location.hostname.indexOf('ulearning') !== -1 || location.hostname.indexOf('zambialearning.net') !== -1) {
  isI18n = true
}

module.exports = {
  UMOOC_COOKIE_DOMAIN: UMOOC_COOKIE_DOMAIN,
  COURSE_API_HOST: COURSE_API_HOST,
  API_HOST: COURSE_API_HOST,
  KG_API_HOST: KG_API_HOST,
  TEST_API_HOST: TEST_API_HOST,
  UTEST_WEB_HOST: UTEST_WEB_HOST,
  UTEST_API_HOST: UTEST_API_HOST,
  UA_API_HOST: UA_API_HOST,
  QINIU_BASE64_URL: QINIU_BASE64_URL,
  RESOURCE_SERVER_HOST: RESOURCE_SERVER_HOST,
  RESOURCE_DOWNLOAD_HOST: RESOURCE_DOWNLOAD_HOST,
  DOCS_HOST: DOCS_HOST,
  UMOBILE_HOST: UMOBILE_HOST,
  UMOOC_SERVER_HOST: UMOOC_SERVER_HOST,
  WXPCLOGINAPPID: WXPCLOGINAPPID,
  WXGZHAPPID: WXGZHAPPID,
  ORG_SITE: ORG_SITE,
  isI18n: isI18n
}
